module.exports = __webpack_public_path__ + "img/PostArztRoutine.94132c6d.svg";